import { Outlet, Navigate } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { MobileNav } from './MobileNav'
import { useApp } from '@/store/AppContext'
import { useEffect } from 'react'
import { useAuth } from '@/hooks/use-auth'
import { Onboarding } from './Onboarding'

export default function Layout() {
  const { settings, isOperationMode } = useApp()
  const { profile, loading } = useAuth()

  const userInitials = profile?.name
    ? profile.name.substring(0, 2).toUpperCase()
    : 'U'

  useEffect(() => {
    document.title = `${settings.name} - Sistema de Estacionamento`
  }, [settings.name])

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        Carregando...
      </div>
    )
  }

  if (!profile) {
    return <Navigate to="/login" />
  }

  return (
    <div className="flex min-h-screen bg-background text-foreground overflow-hidden">
      <Sidebar className="hidden md:flex w-64 flex-shrink-0 z-10 shadow-sm" />
      <main className="flex-1 flex flex-col relative h-screen overflow-hidden">
        {/* Mobile Header Top */}
        {!isOperationMode && (
          <div className="md:hidden flex items-center justify-between p-4 bg-primary text-primary-foreground shadow-sm z-10">
            <h1 className="font-bold text-lg truncate pr-2 tracking-tight">
              {settings.name}
            </h1>
            <div className="h-8 w-8 rounded-full bg-white/20 flex items-center justify-center text-sm font-bold flex-shrink-0 border border-white/30">
              {userInitials}
            </div>
          </div>
        )}

        {/* Scrollable Content */}
        <div
          className={`flex-1 overflow-y-auto ${isOperationMode ? 'p-2 md:p-6 pb-24 md:pb-6' : 'p-4 md:p-8 pb-24 md:pb-8'} scroll-smooth`}
        >
          <div className="max-w-7xl mx-auto w-full animate-fade-in h-full">
            <Outlet />
          </div>
        </div>

        {/* Global Onboarding Overlay */}
        <Onboarding />
      </main>
      <MobileNav className="md:hidden fixed bottom-0 left-0 right-0" />
    </div>
  )
}
